import { render, staticRenderFns } from "./questionarioInizialeOptions.vue?vue&type=template&id=566a4dfe&scoped=true&"
import script from "./questionarioInizialeOptions.vue?vue&type=script&lang=ts&"
export * from "./questionarioInizialeOptions.vue?vue&type=script&lang=ts&"
import style0 from "./questionarioInizialeOptions.vue?vue&type=style&index=0&id=566a4dfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566a4dfe",
  null
  
)

export default component.exports